<template>
    <div>
        <nav v-on:submit.prevent="searchSheet" class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline">
                    <input class="form-control mr-sm-2"
                           v-model="search.code"
                           type="search"
                           v-on=""
                           placeholder="รหัส"
                           aria-label="Search"/>
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="searchSheet"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp
                    <template v-if="canInventorySheetsUpdate">
                        <router-link to="sheet-information">
                            <button
                                    class="btn btn-warning my-2 my-sm-0"
                                    type="button">
                                <icon name="plus"></icon>
                                เพิ่มชีท
                            </button>
                        </router-link>
                    </template>
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <template v-if="canInventorySheetsImport">
                        <th scope="col">นำเข้าชีท</th>
                    </template>
                    <template v-if="canInventorySheetsExport">
                        <th scope="col">เบิกชีท</th>
                    </template>
                    <th scope="col">รหัสชีท</th>
                    <th scope="col">ชีท</th>
                    <th scope="col">ประเภทชีท</th>
                    <th scope="col">จำนวนคงเหลือ</th>
                    <th scope="col">วันที่อัพเดตล่าสุด</th>
                    <template v-if="canInventorySheetsUpdate">
                        <th scope="col">แก้ไข</th>
                    </template>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in sheet">
                    <template v-if="canInventorySheetsImport">
                        <td>
                            <a @click="showSheetImportModal(data.id)">
                                <img src="@/assets/plus_icon.png" width="40px"/>
                            </a>
                        </td>
                    </template>
                    <template v-if="canInventorySheetsExport">
                        <td>
                            <a @click="showSheetExportModal(data.id)">
                                <img src="@/assets/delete_icon.png" width="40px"/>
                            </a>
                        </td>
                    </template>
                    <td>{{ data.code }}</td>
                    <td>{{ data.name }}</td>
                    <td>
                        <template v-if="data.sheet_type">
                            {{ data.sheet_type.name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>{{ data.quantity | amount }}</td>
                    <td>{{ data.updated_at | moment("DD/MM/YYYY , H:mm:ss") }}</td>
                    <template v-if="canInventorySheetsUpdate">
                        <td>
                            <a @click="goToSheetInformation(data.id)">
                                <icon name="pencil-alt"></icon>
                            </a>
                            &nbsp;&nbsp;
                        </td>
                    </template>
                </tr>
                </tbody>
            </table>
        </div>
        <br />
        <!--paginate-->
        <div v-if="sheet.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getSheetPage">
            </vue-pagination>
        </div>
        <br/>
        <!-- Modal Import Data -->
        <b-modal
            hide-footer
            ref="import_data"
            id="import"
            title="นำเข้าชีท">
            <import-sheet-modal @submit="saveSheetImport">
            </import-sheet-modal>
        </b-modal>
        <!-- Modal export Data -->
        <b-modal
            hide-footer
            ref="export_data"
            id="import"
            title="เบิกชีท">
            <export-sheet-modal @submit="saveSheetExport">
            </export-sheet-modal>
        </b-modal>
        <!--<pre class="alert alert-primary">{{ sheet }}</pre>-->
    </div>
</template>

<script>
import { mapState } from "vuex";
import ImportSheetModal from "../Import/ImportSheetModal";
import ExportSheetModal from "../Export/ExportSheetModal";
import VuePagination from "../../Pagination";
import {
    canInventorySheetsImport,
    canInventorySheetsExport,
    canInventorySheetsUpdate
} from "../../../util/Permissions";

export default {
    name: "sheet-list",
    components: {
        VuePagination,
        ExportSheetModal,
        ImportSheetModal
    },
    data() {
        return {

            id: "",
            event_submit : false,
        };
    },
    created() {
        this.$store.dispatch("Sheet/get");
    },
    computed: {
        canInventorySheetsImport,
        canInventorySheetsExport,
        canInventorySheetsUpdate,
        ...mapState({
            sheet: state => {
                return state.Sheet.table;
            },
            dataPaginate:state=>{
                return state.Sheet.dataPaginate;
            },
            search:state =>{
                return state.Sheet.search;
            }
        })
    },
    methods: {
        //Modal
        showSheetImportModal(id) {
            this.showSheet(id);
            this.$refs.import_data.show();
        },
        showSheetExportModal(id) {
            this.showSheet(id);
            this.$refs.export_data.show();
        },
        hideSheetImportModal() {
            this.$refs.import_data.hide();
        },
        hideSheetExportModal() {
            this.$refs.export_data.hide();
        },
        //API
        showSheet(id) {
            this.$store.dispatch("Sheet/show", id);
        },
        saveSheetImport(submitData) {
            if(submitData!=="cancel"){
                return this.$store.dispatch("ImportSheet/create", submitData).then(() => {
                    this.$router.push({ name: "sheet-import" });
                });
            }
            this.hideSheetImportModal();
        },
        saveSheetExport(submitData) {
            if(submitData!=="cancel"){
                return this.$store.dispatch("ExportSheet/create", submitData).then(data => {
                    if(!data){
                        alert("กรุณาใส่หมายเหตุไม่เกิน 255 ตัวอักษร")
                    }else{
                        this.$router.push({ name: "sheet-export" });
                    }
                });
            }
            this.hideSheetExportModal();
        },
        searchSheet() {
            this.event_submit = true;
            this.$store.dispatch("Sheet/search", {
                code:this.search.code
            });
        },
        //function
        goToSheetInformation(id) {
            this.showSheet(id);
            this.$router.push({
                name: "sheet-information",
                params: { id }
            });
        },
        getSheetPage(){
            const page = this.dataPaginate.current_page;
            if(this.event_submit){
                this.$store.dispatch("Sheet/search", {
                    page:page,
                    code:this.search.code
                });
            }else{
                this.$store.dispatch('Sheet/get',page);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
    /*td:nth-of-type(1):before {*/
        /*content: "นำเข้าชีท";*/
    /*}*/
    /*td:nth-of-type(2):before {*/
        /*content: "เบิกชีท";*/
    /*}*/
    /*td:nth-of-type(3):before {*/
        /*content: "รหัสชีท";*/
    /*}*/
    /*td:nth-of-type(4):before {*/
        /*content: "ชีท";*/
    /*}*/
    /*td:nth-of-type(5):before {*/
        /*content: "ประเภทชีท";*/
    /*}*/
    /*td:nth-of-type(6):before {*/
        /*content: "จำนวนคงเหลือ";*/
    /*}*/
    /*td:nth-of-type(7):before {*/
        /*content: "วันที่อัพเดตล่าสุด";*/
    /*}*/
    /*td:nth-of-type(8):before {*/
        /*content: "แก้ไข / ลบ";*/
    /*}*/
</style>
